// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu_wrapper__N1Ak8 {
  --bottomBarHeight: 72px;
  --topBarHeight: 54px;
  --menuPrimaryColor: var(--primaryColor);
  --menuTextColor: var(--textColor);

  position: absolute;
  z-index: 10;
  right: 0;
  bottom: 72px;
  bottom: var(--bottomBarHeight);

  display: flex;
  flex-direction: column;

  width: 350px;
  min-width: 350px;
  max-height: calc(100% - 72px);
  max-height: calc(100% - var(--bottomBarHeight));

  font-size: 12px;
  line-height: 15px;
  color: var(--menuTextColor);

  background: var(--backgroundColor);
  outline: none;
  box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.25);

  transition-duration: 0.2s;
  transition-property: opacity, visibility, transform;
}

.menu_wrapper__N1Ak8.menu_top__vdX71 {
    top: var(--topBarHeight);
    bottom: auto;
    max-height: calc(100% - var(--topBarHeight) - var(--bottomBarHeight));
  }

.menu_wrapper__N1Ak8.menu_closed__XMbNa {
    pointer-events: none;

    transform: scale(0.95);

    visibility: hidden;
    visibility: collapse;
    opacity: 0;
  }

.menu_wrapper__N1Ak8 button {
    cursor: pointer;
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;

    border: none;

    font: inherit;
    font-size: 12px;
    color: var(--menuTextColor);

    background: none;
    outline: none;
  }

.menu_wrapper__N1Ak8 button:focus-visible {
      outline: 2px solid var(--primaryColor);
    }

.menu_wrapper__N1Ak8 .menu_menu__uksdi {
    display: flex;
    flex-direction: column;

    width: 100%;
    min-height: 0;
    max-height: 100%;
  }

.menu_wrapper__N1Ak8 .menu_menuContent__4bLMh {
    overflow-x: hidden;
    overflow-y: auto;
    overflow: hidden auto;
    padding: 2px;
  }

.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm {
    display: flex;
    flex-shrink: 0;
    gap: 16px;
    align-items: center;

    width: 100%;
    height: 60px;
    padding: 18px 20px;

    transition-duration: 0.2s;
    transition-property: color, fill, background-color;
  }

.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm.menu_active__pS7yB svg {
      color: var(--menuPrimaryColor);
      fill: var(--menuPrimaryColor);
    }

.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm.menu_disabled__1VVyY {
      cursor: default;
    }

.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm:focus-visible {
      position: relative;
      z-index: 1;
      outline: 2px solid var(--primaryColor);
    }

.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm .menu_menuItemLabel__6EUeI {
      flex-grow: 1;
      text-align: left;
    }

.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm .menu_menuItemLabelText__Dhx0s {
      position: relative;

      display: flex;
      gap: 16px;
      align-items: center;

      max-width: -webkit-fit-content;

      max-width: -moz-fit-content;

      max-width: fit-content;

      font-size: 12px;
      color: var(--menuTextColor);
    }

.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm .menu_menuItemLabelText__Dhx0s::after {
        content: '';

        position: absolute;
        bottom: -7px;

        display: block;

        width: 0;
        height: 3px;

        opacity: 0;
        background: var(--menuPrimaryColor);

        transition-duration: 0.1s, 0.2s;
        transition-property: width, opacity;
      }

.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm:not(.menu_disabled__1VVyY):not(.menu_menuHeader__7T-l1):hover .menu_menuItemLabelText__Dhx0s::after {
      width: 100%;
      opacity: 1;
    }

.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm .menu_leftIcon__KeaJ2,.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm .menu_rightIcon__e1F1c {
      flex-shrink: 0;
    }

.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm.menu_menuHeader__7T-l1 {
      cursor: pointer;
    }

.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm.menu_menuHeader__7T-l1.menu_disabled__1VVyY:not(.menu_showHeader__RCynZ),.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm.menu_menuHeader__7T-l1.menu_hideHeader__5qchT {
      display: none;
    }

.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm .menu_submenuButton__gOqU5 {
      height: 24px;
    }

.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm .menu_submenuButton__gOqU5 span {
        position: relative;
        display: flex;
        gap: 4px;
        align-items: center;
      }

.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm .menu_submenuButton__gOqU5 span::after {
          content: '';

          position: absolute;
          bottom: -7px;

          display: block;

          width: 0;
          height: 3px;

          opacity: 0;
          background: var(--menuPrimaryColor);

          transition-duration: 0.1s, 0.2s;
          transition-property: width, opacity;
        }

.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm .menu_submenuButton__gOqU5:hover span::after {
        width: 100%;
        opacity: 1;
      }

.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm .menu_submenuButton__gOqU5 svg {
        height: 0.75em;
      }

.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm .menu_goBackButton__5Kn50 {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 24px;
    }

.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm .menu_goBackButton__5Kn50 svg {
        transform: rotateY(180deg);
      }

.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm .menu_icon__uPvFe {
      display: flex;
      align-items: center;
      justify-content: center;

      width: 24px;
      height: 24px;

      fill: var(--menuTextColor);
    }

.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm .menu_icon__uPvFe svg {
        color: var(--menuTextColor);
        fill: var(--menuTextColor);
      }

.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm .menu_icon__uPvFe,.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm .menu_icon__uPvFe svg {
        transition-duration: 0.2s;
        transition-property: color, fill, opacity;
      }

.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm:not(.menu_disabled__1VVyY):hover .menu_icon__uPvFe {
      color: var(--menuPrimaryColor);
    }

.menu_wrapper__N1Ak8 .menu_menuItem__R7xkm:not(.menu_disabled__1VVyY):hover .menu_icon__uPvFe svg {
        color: var(--menuPrimaryColor);
        fill: var(--menuPrimaryColor);
      }

.menu_wrapper__N1Ak8 .menu_menuItemsWrapper__mzevy {
    overflow: auto;
    display: flex;
    flex-direction: column;

    min-height: 0px;
    padding: 2px;
  }

.menu_wrapper__N1Ak8 .menu_close__8g6hF {
    display: none;

    width: 24px;
    height: 24px;
    padding: 0;

    transition-duration: 0.2s;
    transition-property: color, fill, opacity;
  }

.menu_wrapper__N1Ak8 .menu_close__8g6hF:hover {
      color: var(--menuPrimaryColor);
      fill: var(--menuPrimaryColor);
    }

@media (prefers-contrast: more) {
    .menu_wrapper__N1Ak8 {
      border: 1px solid var(--borderColor);
    }
  }

@media (forced-colors: active) {
    .menu_wrapper__N1Ak8 {
      --menuPrimaryColor: Highlight;
      --menuTextColor: ButtonText;

      border: 1px solid ButtonBorder;
    }
    .menu_wrapper__N1Ak8 .menu_menuItem__R7xkm {
      border-bottom: 1px solid ButtonBorder;
    }
  }

/* Smaller screens / mobile */
.smallScreen .menu_wrapper__N1Ak8 {
    top: 0;
    right: 0;
    bottom: 0;

    width: 100%;
    min-width: 0;
    height: 100%;
    max-height: 100%;
    padding: 4px;

    background: color(from var(--backgroundColor) srgb r g b / 0.9);
  }
.smallScreen .menu_wrapper__N1Ak8 .menu_menuItem__R7xkm.menu_menuHeader__7T-l1:not(.menu_hideHeader__5qchT) {
      display: flex;
    }
.smallScreen .menu_wrapper__N1Ak8 .menu_menuItem__R7xkm.menu_menuHeader__7T-l1:not(.menu_hideHeader__5qchT) .menu_close__8g6hF {
        display: inline;
        display: initial;
      }

@media (prefers-reduced-motion) {
  .menu_wrapper__N1Ak8,
  .menu_wrapper__N1Ak8 * {
    transition: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/menu/menu.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,uCAAuC;EACvC,iCAAiC;;EAEjC,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,YAA8B;EAA9B,8BAA8B;;EAE9B,aAAa;EACb,sBAAsB;;EAEtB,YAAY;EACZ,gBAAgB;EAChB,6BAA+C;EAA/C,+CAA+C;;EAE/C,eAAe;EACf,iBAAiB;EACjB,2BAA2B;;EAE3B,kCAAkC;EAClC,aAAa;EACb,+CAA+C;;EAE/C,yBAAyB;EACzB,mDAAmD;AA4PrD;;AA1PE;IACE,wBAAwB;IACxB,YAAY;IACZ,qEAAqE;EACvE;;AAEA;IACE,oBAAoB;;IAEpB,sBAAsB;;IAEtB,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;EACZ;;AAEA;IACE,eAAe;IACf,yBAAiB;OAAjB,sBAAiB;YAAjB,iBAAiB;;IAEjB,YAAY;;IAEZ,aAAa;IACb,eAAe;IACf,2BAA2B;;IAE3B,gBAAgB;IAChB,aAAa;EAKf;;AAHE;MACE,sCAAsC;IACxC;;AAGF;IACE,aAAa;IACb,sBAAsB;;IAEtB,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;;AAEA;IACE,kBAAqB;IAArB,gBAAqB;IAArB,qBAAqB;IACrB,YAAY;EACd;;AAEA;IACE,aAAa;IACb,cAAc;IACd,SAAS;IACT,mBAAmB;;IAEnB,WAAW;IACX,YAAY;IACZ,kBAAkB;;IAElB,yBAAyB;IACzB,kDAAkD;EAmJpD;;AAjJE;MACE,8BAA8B;MAC9B,6BAA6B;IAC/B;;AAEA;MACE,eAAe;IACjB;;AACA;MACE,kBAAkB;MAClB,UAAU;MACV,sCAAsC;IACxC;;AAEA;MACE,YAAY;MACZ,gBAAgB;IAClB;;AACA;MACE,kBAAkB;;MAElB,aAAa;MACb,SAAS;MACT,mBAAmB;;MAEnB,8BAAsB;;MAAtB,2BAAsB;;MAAtB,sBAAsB;;MAEtB,eAAe;MACf,2BAA2B;IAmB7B;;AAjBE;QACE,WAAW;;QAEX,kBAAkB;QAClB,YAAY;;QAEZ,cAAc;;QAEd,QAAQ;QACR,WAAW;;QAEX,UAAU;QACV,mCAAmC;;QAEnC,+BAA+B;QAC/B,mCAAmC;MACrC;;AAGF;MACE,WAAW;MACX,UAAU;IACZ;;AAEA;MAEE,cAAc;IAChB;;AAEA;MACE,eAAe;IACjB;;AACA;MAEE,aAAa;IACf;;AAEA;MACE,YAAY;IAmCd;;AAjCE;QACE,kBAAkB;QAClB,aAAa;QACb,QAAQ;QACR,mBAAmB;MAmBrB;;AAjBE;UACE,WAAW;;UAEX,kBAAkB;UAClB,YAAY;;UAEZ,cAAc;;UAEd,QAAQ;UACR,WAAW;;UAEX,UAAU;UACV,mCAAmC;;UAEnC,+BAA+B;UAC/B,mCAAmC;QACrC;;AAGF;QACE,WAAW;QACX,UAAU;MACZ;;AAEA;QACE,cAAc;MAChB;;AAGF;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,YAAY;IAKd;;AAHE;QACE,0BAA0B;MAC5B;;AAEF;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;;MAEvB,WAAW;MACX,YAAY;;MAEZ,0BAA0B;IAY5B;;AAVE;QACE,2BAA2B;QAC3B,0BAA0B;MAC5B;;AAEA;QAEE,yBAAyB;QACzB,yCAAyC;MAC3C;;AAGF;MACE,8BAA8B;IAMhC;;AAJE;QACE,8BAA8B;QAC9B,6BAA6B;MAC/B;;AAIJ;IACE,cAAc;IACd,aAAa;IACb,sBAAsB;;IAEtB,eAAe;IACf,YAAY;EACd;;AAEA;IACE,aAAa;;IAEb,WAAW;IACX,YAAY;IACZ,UAAU;;IAEV,yBAAyB;IACzB,yCAAyC;EAM3C;;AAJE;MACE,8BAA8B;MAC9B,6BAA6B;IAC/B;;AAGF;IACE;MACE,oCAAoC;IACtC;EACF;;AAEA;IACE;MACE,6BAA6B;MAC7B,2BAA2B;;MAE3B,8BAA8B;IAChC;IACA;MACE,qCAAqC;IACvC;EACF;;AAGF,6BAA6B;AAE3B;IACE,MAAM;IACN,QAAQ;IACR,SAAS;;IAET,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,YAAY;;IAEZ,+DAA+D;EAQjE;AANE;MACE,aAAa;IAIf;AAHE;QACE,eAAgB;QAAhB,gBAAgB;MAClB;;AAKN;EACE;;IAEE,2BAA2B;EAC7B;AACF","sourcesContent":[".wrapper {\n  --bottomBarHeight: 72px;\n  --topBarHeight: 54px;\n  --menuPrimaryColor: var(--primaryColor);\n  --menuTextColor: var(--textColor);\n\n  position: absolute;\n  z-index: 10;\n  right: 0;\n  bottom: var(--bottomBarHeight);\n\n  display: flex;\n  flex-direction: column;\n\n  width: 350px;\n  min-width: 350px;\n  max-height: calc(100% - var(--bottomBarHeight));\n\n  font-size: 12px;\n  line-height: 15px;\n  color: var(--menuTextColor);\n\n  background: var(--backgroundColor);\n  outline: none;\n  box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.25);\n\n  transition-duration: 0.2s;\n  transition-property: opacity, visibility, transform;\n\n  &.top {\n    top: var(--topBarHeight);\n    bottom: auto;\n    max-height: calc(100% - var(--topBarHeight) - var(--bottomBarHeight));\n  }\n\n  &.closed {\n    pointer-events: none;\n\n    transform: scale(0.95);\n\n    visibility: hidden;\n    visibility: collapse;\n    opacity: 0;\n  }\n\n  & button {\n    cursor: pointer;\n    user-select: none;\n\n    border: none;\n\n    font: inherit;\n    font-size: 12px;\n    color: var(--menuTextColor);\n\n    background: none;\n    outline: none;\n\n    &:focus-visible {\n      outline: 2px solid var(--primaryColor);\n    }\n  }\n\n  & .menu {\n    display: flex;\n    flex-direction: column;\n\n    width: 100%;\n    min-height: 0;\n    max-height: 100%;\n  }\n\n  & .menuContent {\n    overflow: hidden auto;\n    padding: 2px;\n  }\n\n  & .menuItem {\n    display: flex;\n    flex-shrink: 0;\n    gap: 16px;\n    align-items: center;\n\n    width: 100%;\n    height: 60px;\n    padding: 18px 20px;\n\n    transition-duration: 0.2s;\n    transition-property: color, fill, background-color;\n\n    &.active svg {\n      color: var(--menuPrimaryColor);\n      fill: var(--menuPrimaryColor);\n    }\n\n    &.disabled {\n      cursor: default;\n    }\n    &:focus-visible {\n      position: relative;\n      z-index: 1;\n      outline: 2px solid var(--primaryColor);\n    }\n\n    & .menuItemLabel {\n      flex-grow: 1;\n      text-align: left;\n    }\n    & .menuItemLabelText {\n      position: relative;\n\n      display: flex;\n      gap: 16px;\n      align-items: center;\n\n      max-width: fit-content;\n\n      font-size: 12px;\n      color: var(--menuTextColor);\n\n      &::after {\n        content: '';\n\n        position: absolute;\n        bottom: -7px;\n\n        display: block;\n\n        width: 0;\n        height: 3px;\n\n        opacity: 0;\n        background: var(--menuPrimaryColor);\n\n        transition-duration: 0.1s, 0.2s;\n        transition-property: width, opacity;\n      }\n    }\n\n    &:not(.disabled):not(.menuHeader):hover .menuItemLabelText::after {\n      width: 100%;\n      opacity: 1;\n    }\n\n    & .leftIcon,\n    & .rightIcon {\n      flex-shrink: 0;\n    }\n\n    &.menuHeader {\n      cursor: pointer;\n    }\n    &.menuHeader.disabled:not(.showHeader),\n    &.menuHeader.hideHeader {\n      display: none;\n    }\n\n    & .submenuButton {\n      height: 24px;\n\n      & span {\n        position: relative;\n        display: flex;\n        gap: 4px;\n        align-items: center;\n\n        &::after {\n          content: '';\n\n          position: absolute;\n          bottom: -7px;\n\n          display: block;\n\n          width: 0;\n          height: 3px;\n\n          opacity: 0;\n          background: var(--menuPrimaryColor);\n\n          transition-duration: 0.1s, 0.2s;\n          transition-property: width, opacity;\n        }\n      }\n\n      &:hover span::after {\n        width: 100%;\n        opacity: 1;\n      }\n\n      & svg {\n        height: 0.75em;\n      }\n    }\n\n    & .goBackButton {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      height: 24px;\n\n      & svg {\n        transform: rotateY(180deg);\n      }\n    }\n    & .icon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      width: 24px;\n      height: 24px;\n\n      fill: var(--menuTextColor);\n\n      & svg {\n        color: var(--menuTextColor);\n        fill: var(--menuTextColor);\n      }\n\n      &,\n      & svg {\n        transition-duration: 0.2s;\n        transition-property: color, fill, opacity;\n      }\n    }\n\n    &:not(.disabled):hover .icon {\n      color: var(--menuPrimaryColor);\n\n      & svg {\n        color: var(--menuPrimaryColor);\n        fill: var(--menuPrimaryColor);\n      }\n    }\n  }\n\n  & .menuItemsWrapper {\n    overflow: auto;\n    display: flex;\n    flex-direction: column;\n\n    min-height: 0px;\n    padding: 2px;\n  }\n\n  & .close {\n    display: none;\n\n    width: 24px;\n    height: 24px;\n    padding: 0;\n\n    transition-duration: 0.2s;\n    transition-property: color, fill, opacity;\n\n    &:hover {\n      color: var(--menuPrimaryColor);\n      fill: var(--menuPrimaryColor);\n    }\n  }\n\n  @media (prefers-contrast: more) {\n    & {\n      border: 1px solid var(--borderColor);\n    }\n  }\n\n  @media (forced-colors: active) {\n    & {\n      --menuPrimaryColor: Highlight;\n      --menuTextColor: ButtonText;\n\n      border: 1px solid ButtonBorder;\n    }\n    & .menuItem {\n      border-bottom: 1px solid ButtonBorder;\n    }\n  }\n}\n\n/* Smaller screens / mobile */\n:global(.smallScreen) {\n  & .wrapper {\n    top: 0;\n    right: 0;\n    bottom: 0;\n\n    width: 100%;\n    min-width: 0;\n    height: 100%;\n    max-height: 100%;\n    padding: 4px;\n\n    background: color(from var(--backgroundColor) srgb r g b / 0.9);\n\n    & .menuItem.menuHeader:not(.hideHeader) {\n      display: flex;\n      & .close {\n        display: initial;\n      }\n    }\n  }\n}\n\n@media (prefers-reduced-motion) {\n  .wrapper,\n  .wrapper * {\n    transition: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `menu_wrapper__N1Ak8`,
	"top": `menu_top__vdX71`,
	"closed": `menu_closed__XMbNa`,
	"menu": `menu_menu__uksdi`,
	"menuContent": `menu_menuContent__4bLMh`,
	"menuItem": `menu_menuItem__R7xkm`,
	"active": `menu_active__pS7yB`,
	"disabled": `menu_disabled__1VVyY`,
	"menuItemLabel": `menu_menuItemLabel__6EUeI`,
	"menuItemLabelText": `menu_menuItemLabelText__Dhx0s`,
	"menuHeader": `menu_menuHeader__7T-l1`,
	"leftIcon": `menu_leftIcon__KeaJ2`,
	"rightIcon": `menu_rightIcon__e1F1c`,
	"showHeader": `menu_showHeader__RCynZ`,
	"hideHeader": `menu_hideHeader__5qchT`,
	"submenuButton": `menu_submenuButton__gOqU5`,
	"goBackButton": `menu_goBackButton__5Kn50`,
	"icon": `menu_icon__uPvFe`,
	"menuItemsWrapper": `menu_menuItemsWrapper__mzevy`,
	"close": `menu_close__8g6hF`
};
module.exports = ___CSS_LOADER_EXPORT___;
